/** Portal Customers e App Go só chegam da API quando o cliente tem a licença. */
export const ALLOWED_BOOK_NAMES = ['Configurações', 'Atualizações', 'Portal Customers', 'App Go', 'Treinamentos'];

export const BOOK_ORDER = {
  Atualizações: 0,
  Configurações: 1,
  'Portal Customers': 2,
  'App Go': 3,
  Treinamentos: 4,
};

export const BOOK_ICONS = {
  Configurações: 'settings',
  Atualizações: 'refresh',
  'Portal Customers': 'customers',
  'App Go': 'go',
  Treinamentos: 'graduation',
};

export function filterAndSortBooks(books) {
  if (!Array.isArray(books)) return [];
  return books
    .filter((book) => ALLOWED_BOOK_NAMES.includes(book.name))
    .sort((a, b) => (BOOK_ORDER[a.name] ?? 99) - (BOOK_ORDER[b.name] ?? 99));
}

export const ATUALIZACOES_BOOK_NAME = 'Atualizações';
const CHAPTER_VERSAO_ATUAL = 'Versão atual';
const CHAPTER_VERSOES_ANTERIORES = 'Versões anteriores';

function parseDateFromPageName(name) {
  if (!name) return null;
  const match = String(name).match(/(\d{2})\/(\d{2})\/(\d{4})\s*$/);
  if (!match) return null;
  const [, dd, mm, yyyy] = match;
  const time = Date.parse(`${yyyy}-${mm}-${dd}T12:00:00`);
  return Number.isNaN(time) ? null : time;
}

function getPageModifiedTime(page) {
  const raw = page?.updated_at || page?.updatedAt || page?.created_at || page?.createdAt;
  if (raw) {
    const time = Date.parse(raw);
    if (!Number.isNaN(time)) return time;
  }
  return parseDateFromPageName(page?.name) ?? 0;
}

export function sortPagesByModifiedDesc(pages) {
  if (!Array.isArray(pages) || pages.length < 2) return pages || [];
  return [...pages].sort((a, b) => getPageModifiedTime(b) - getPageModifiedTime(a));
}

function enrichChapterPages(items, pageMetaById) {
  if (!pageMetaById?.size) return items;
  return items.map((item) => {
    if (item.type !== 'chapter' || !Array.isArray(item.pages)) return item;
    const pages = item.pages.map((page) => {
      const meta = pageMetaById.get(page.id);
      return meta ? { ...page, ...meta } : page;
    });
    return { ...item, pages };
  });
}

export function prepareBookContents(bookName, items, pageMetaById) {
  if (!Array.isArray(items)) return [];

  const chapterOrder = (name) => {
    if (name === CHAPTER_VERSAO_ATUAL) return 0;
    if (name === CHAPTER_VERSOES_ANTERIORES) return 1;
    return 2;
  };

  let prepared = enrichChapterPages(items, pageMetaById).map((item) => {
    if (item.type === 'chapter' && Array.isArray(item.pages)) {
      return { ...item, pages: sortPagesByModifiedDesc(item.pages) };
    }
    return item;
  });

  if (bookName === ATUALIZACOES_BOOK_NAME) {
    const chapters = prepared.filter((item) => item.type === 'chapter');
    const pages = sortPagesByModifiedDesc(prepared.filter((item) => item.type === 'page'));
    chapters.sort(
      (a, b) => chapterOrder(a.name) - chapterOrder(b.name) || (a.priority ?? 0) - (b.priority ?? 0)
    );
    return [...chapters, ...pages];
  }

  if (!prepared.some((item) => item.type === 'chapter')) {
    return sortPagesByModifiedDesc(prepared.filter((item) => item.type === 'page'));
  }

  return prepared;
}

export function getInitialExpandedChapters(bookName, items) {
  const expanded = {};
  if (!Array.isArray(items)) return expanded;
  items.forEach((item) => {
    if (item.type !== 'chapter') return;
    if (bookName === ATUALIZACOES_BOOK_NAME) {
      expanded[item.id] = item.name === CHAPTER_VERSAO_ATUAL;
    } else {
      expanded[item.id] = true;
    }
  });
  return expanded;
}
